module.exports = __webpack_public_path__ + "static/media/tile.fd1aa1d6.md";